"use client";

import React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certifications = [{
  id: "naic",
  name: "National Association of Insurance Commissioners",
  description: "Adherence to the highest regulatory standards for consumer protection and market integrity.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/naic_compliance_seal.png"
}, {
  id: "bbb",
  name: "Better Business Bureau A+ Rated",
  description: "Recognized for superior commitment to customer service and ethical business practices.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/bbb_accredited_business.png"
}, {
  id: "limra",
  name: "LIMRA Member",
  description: "Committed to industry-leading research and professional development in life insurance.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/limra_industry_member.png"
}, {
  id: "finra",
  name: "FINRA Registered",
  description: "Ensuring all financial interactions meet rigorous federal transparency and safety guidelines.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/finra_registered_agent.png"
}];
export default function IndustryCredentials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224400" id="industry-credentials" className="w-full py-16 md:py-24 bg-background border-y border-border/30">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">
            Industry Credentials & Trust
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-default">
            LIFECOVER is backed by the world's leading insurance authorities, ensuring your family's future is protected by certified excellence.
          </p>
        </div>

        <div ref={gridRef} className={`flex flex-wrap justify-center items-center gap-8 md:gap-16 lg:gap-24 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {certifications.map((cert, index) => <div data-index={index} key={cert.id} className="flex justify-center">
              <HoverCard>
                <HoverCardTrigger className="cursor-pointer group p-4 rounded-lg transition-colors hover:bg-accent/50">
                  <img src={cert.logo} alt={`Logo of ${cert.name}`} className="h-12 md:h-16 lg:h-20 w-auto object-contain grayscale opacity-50 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105" />
                </HoverCardTrigger>
                <HoverCardContent className="w-72 md:w-80 p-5 rounded-lg shadow-xl border-border/50 bg-card/95 backdrop-blur-md" sideOffset={16}>
                  <div className="space-y-2">
                    <h4 className="text-sm md:text-base font-semibold font-default text-foreground leading-tight">
                      {cert.name}
                    </h4>
                    <p className="text-sm text-muted-foreground font-default leading-relaxed">
                      {cert.description}
                    </p>
                  </div>
                </HoverCardContent>
              </HoverCard>
            </div>)}
        </div>
      </div>
    </section>;
}